import { AuthGuard } from '@/auth/auth-guards';
import { activationTabsMessages } from '@/components/Activations/Layout/ActivationTabsMessages';
import { useAuthorizationStore } from '@/stores/AuthorizationStore/AuthorizationStore';
import { isViewingRoomsEnabled } from '@/utils/featureFlagUtils';
import { activationRoutePaths } from '@/views/activation/activation-route-paths';
import { ActivationViewType, Permission, Subscription } from '@art-basel/artbasel-lib-platform';
import type { RouteLocation, RouteRecordRaw } from 'vue-router';

export const activationRoutes: Array<RouteRecordRaw> = [
  {
    meta: { title: activationTabsMessages.dashboard },
    path: activationRoutePaths.ACTIVATION,
    beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_ACTIVATIONS),
    children: [
      {
        meta: { title: activationTabsMessages.new },
        path: activationRoutePaths.INDEX,
        component: () => {
          const { hasSubscription } = useAuthorizationStore();
          return isViewingRoomsEnabled() && hasSubscription(Subscription.EXHIBITOR_API)
            ? import(`./ActivationsV2.vue`) : import(`./Activations.vue`);
        },
        beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_ACTIVATIONS),
      },
      {
        path: activationRoutePaths.ID,
        component: () => import(`./configure-activation/ConfigureActivation.vue`),
        beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_ACTIVATIONS),
      },
      {
        meta: { title: activationTabsMessages.dashboard },
        path: activationRoutePaths.CONFIGURE,
        component: () => import(`./configure-activation/ConfigureActivation.vue`),
        beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_ACTIVATIONS),
      },
      {
        meta: { title: activationTabsMessages.settings },
        path: activationRoutePaths.NEW,
        component: () => import(`./configure-activation/ConfigureActivation.vue`),
        beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_ACTIVATIONS),
      },
      {
        meta: { title: activationTabsMessages.settings },
        path: activationRoutePaths.CREATE_VIEWING_ROOMS,
        component: () => import(`./configure-activation/ConfigureActivation.vue`),
        beforeEnter: (to: RouteLocation) => AuthGuard(to, Permission.READ_ACTIVATIONS),
        props: { viewType: ActivationViewType.VIEWING_ROOM },
      },
    ],
  },
];
